document.addEventListener('DOMContentLoaded', function () {
  initHeroSlider();
  initBrandsCarousel();
  initMobileMenu();
  initSearch();
  initWishlist();
});

// ── Hero slider ──────────────────────────────────────────────
function initHeroSlider() {
  const slider = document.getElementById('hero-slider');
  if (!slider) return;
  const slides = slider.querySelectorAll('.hero-slide');
  if (slides.length <= 1) return;

  const dots = document.querySelectorAll('.hero-dot');
  let current = 0;
  let timer;

  function goTo(i) {
    current = (i + slides.length) % slides.length;
    slider.style.transform = 'translateX(' + (current * -100) + '%)';
    dots.forEach((d, idx) => d.classList.toggle('active', idx === current));
  }

  document.getElementById('hero-prev')?.addEventListener('click', () => { goTo(current - 1); resetTimer(); });
  document.getElementById('hero-next')?.addEventListener('click', () => { goTo(current + 1); resetTimer(); });
  dots.forEach((d, i) => d.addEventListener('click', () => { goTo(i); resetTimer(); }));

  function resetTimer() { clearInterval(timer); timer = setInterval(() => goTo(current + 1), 5000); }
  resetTimer();

  let tx = 0;
  slider.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
  slider.addEventListener('touchend', e => {
    const diff = tx - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) { goTo(diff > 0 ? current + 1 : current - 1); resetTimer(); }
  });
}

// ── Brands carousel ──────────────────────────────────────────
function initBrandsCarousel() {
  const track = document.getElementById('brands-track');
  if (!track) return;

  const cards = track.querySelectorAll('.brand-card');
  const dotsEl = document.getElementById('brands-dots');
  if (!cards.length) return;

  // Cards visible depends on viewport
  function visibleCount() {
    if (window.innerWidth < 600) return 2;
    if (window.innerWidth < 900) return 3;
    return 4;
  }

  let pos = 0;
  const total = cards.length;

  function maxPos() { return Math.max(0, total - visibleCount()); }

  function render() {
    const cardW = cards[0].getBoundingClientRect().width;
    const gap = 16;
    track.style.transform = 'translateX(' + (pos * -(cardW + gap)) + 'px)';
    if (dotsEl) {
      const pages = Math.ceil(total / visibleCount());
      if (!dotsEl.children.length) {
        for (let i = 0; i < pages; i++) {
          const d = document.createElement('button');
          d.className = 'brands-dot' + (i === 0 ? ' active' : '');
          d.addEventListener('click', () => { pos = i * visibleCount(); pos = Math.min(pos, maxPos()); render(); updateDots(); });
          dotsEl.appendChild(d);
        }
      }
    }
  }

  function updateDots() {
    if (!dotsEl) return;
    const page = Math.floor(pos / visibleCount());
    dotsEl.querySelectorAll('.brands-dot').forEach((d, i) => d.classList.toggle('active', i === page));
  }

  document.getElementById('brands-prev')?.addEventListener('click', () => {
    pos = Math.max(0, pos - visibleCount());
    render(); updateDots();
  });
  document.getElementById('brands-next')?.addEventListener('click', () => {
    pos = Math.min(maxPos(), pos + visibleCount());
    render(); updateDots();
  });

  render();
  window.addEventListener('resize', () => { pos = 0; render(); });
}

// ── Mobile menu ───────────────────────────────────────────────
function initMobileMenu() {
  const toggle = document.getElementById('mobile-toggle');
  const nav = document.getElementById('mobile-nav');
  const overlay = document.getElementById('mobile-overlay');
  const close = document.getElementById('mobile-close');

  function open() { nav.classList.add('open'); overlay.classList.add('active'); document.body.style.overflow = 'hidden'; }
  function shut() { nav.classList.remove('open'); overlay.classList.remove('active'); document.body.style.overflow = ''; }

  toggle?.addEventListener('click', open);
  close?.addEventListener('click', shut);
  overlay?.addEventListener('click', shut);
}

// ── Search overlay ────────────────────────────────────────────
function initSearch() {
  const overlay = document.getElementById('search-overlay');
  document.getElementById('search-toggle')?.addEventListener('click', () => {
    overlay?.classList.add('active');
    overlay?.querySelector('input')?.focus();
  });
  document.getElementById('search-close')?.addEventListener('click', () => overlay?.classList.remove('active'));
  overlay?.addEventListener('click', e => { if (e.target === overlay) overlay.classList.remove('active'); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') overlay?.classList.remove('active'); });
}

// ── Wishlist toggle (UI only) ─────────────────────────────────
function initWishlist() {
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const icon = btn.querySelector('i');
      icon.classList.toggle('far');
      icon.classList.toggle('fas');
      icon.style.color = icon.classList.contains('fas') ? '#c9372c' : '';
    });
  });
}
